import styled, { css } from 'styled-components';
import Flex from '../../atoms/Flex';
export const Container = styled.div`
  ${({
  isVerticalView
}) => isVerticalView && css`
      margin: 36px 8px 20px;
      box-shadow: rgb(0 0 0 / 11%) 0px 1px 10px 0px;
    `}
`;
export const ListContentContainer = styled(Flex).attrs(props => Object.assign({
  bg: 'background.white'
}, props))``;